const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    loop: true,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true, // 前後を重ねてフェード（おすすめ）
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
});